import { AUTH_SESSION_KEY } from '../authConfig';

function decodeBase64Url(input) {
  const normalized = input.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
  return atob(padded);
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch (error) {
    console.warn('Unable to decode auth token payload', error);
    return null;
  }
}

export function getStoredAuthSession() {
  const raw = localStorage.getItem(AUTH_SESSION_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse stored auth session', error);
    return null;
  }
}

export function setStoredAuthSession(session) {
  localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
}

export function clearStoredAuthSession() {
  localStorage.removeItem(AUTH_SESSION_KEY);
}

export function getStoredAuthToken() {
  const session = getStoredAuthSession();
  if (!session || !session.token) {
    return null;
  }

  const payload = decodeJwtPayload(session.token);
  if (payload && payload.exp && payload.exp * 1000 < Date.now()) {
    clearStoredAuthSession();
    return null;
  }

  return session.token;
}

export function isAuthenticated() {
  return Boolean(getStoredAuthToken());
}

export function hydrateAuthSessionFromQueryString(search) {
  const params = new URLSearchParams(search);
  const token = params.get('token');
  if (!token) {
    return false;
  }

  const payload = decodeJwtPayload(token) || {};
  setStoredAuthSession({
    token,
    email: params.get('email') || payload.email || payload.preferred_username || null,
    name: params.get('name') || payload.name || null,
    preferredUsername: params.get('preferred_username') || payload.preferred_username || null,
    expiresAt: payload.exp ? payload.exp * 1000 : null,
  });

  return true;
}
